export default "__VITE_ASSET__BfHVqEoo__"